module.exports = ".no-padding {\n  padding: 0; }\n"